import React from 'react';
import './ServicePages.css';

const DataAnalyticsPage = ({ onContactClick }) => {
  const features = [
    { icon: "📊", title: "Interactive Dashboards", desc: "Build real-time dashboards that provide instant visibility into KPIs and business metrics." },
    { icon: "📈", title: "Predictive Analytics", desc: "Forecast trends, demand, and outcomes using advanced statistical and ML models." },
    { icon: "🔄", title: "ETL & Data Pipelines", desc: "Automate data extraction, transformation, and loading from multiple sources into a unified view." },
    { icon: "🗄️", title: "Data Warehousing", desc: "Design scalable cloud data warehouses optimized for fast queries and analytics workloads." },
    { icon: "🎯", title: "Customer Analytics", desc: "Understand customer behavior, segments, and lifetime value with advanced analytics." },
    { icon: "🔍", title: "Anomaly Detection", desc: "Automatically detect unusual patterns, outliers, and potential fraud in your data streams." }
  ];

  return (
    <div className="service-page theme-analytics">
      <section className="svc-hero">
        <div className="svc-hero-content">
          <h1 className="svc-hero-title">Data Analytics<br/>Services</h1>
          <p className="svc-hero-subtitle">TURN RAW DATA INTO ACTIONABLE BUSINESS INTELLIGENCE.</p>
          <p className="svc-hero-desc">End-to-end data analytics solutions — from data engineering and warehousing to advanced analytics and visualization.</p>
          <div className="svc-hero-stats">
            <div className="svc-stat-item"><h3>40%</h3><p>Faster Decision Making</p></div>
            <div className="svc-stat-item"><h3>3x</h3><p>Data Processing Speed</p></div>
            <div className="svc-stat-item"><h3>95%</h3><p>Forecast Accuracy</p></div>
          </div>
          <div className="svc-hero-cta">
            <button className="svc-btn-primary" onClick={onContactClick}>Book a Call</button>
            <button className="svc-btn-secondary"><span>▶</span> See Demo</button>
          </div>
        </div>
        <div className="svc-hero-visual">
          <div className="svc-glowing-ring">📊</div>
        </div>
      </section>

      <section className="svc-features-section">
        <h2 className="svc-section-title">Analytics Capabilities</h2>
        <div className="svc-features-grid">
          {features.map((f, i) => (
            <div key={i} className="svc-feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="svc-cta-section">
        <div className="svc-cta-content">
          <h2>Ready to become data-driven?</h2>
          <p>Book a call and we'll audit your data stack and build a roadmap for analytics excellence.</p>
          <button className="svc-btn-cta" onClick={onContactClick}>Book a Call</button>
        </div>
      </section>
    </div>
  );
};

export default DataAnalyticsPage;
